export default {
  blue: '#007db8',
  darkBlue: '#00447c',
  white: '#ffffff',
  black: '#000000',
  mediumGray: '#aaaaaa',
  paleBlue: '#006bbd',
  paleGray: '#eeeeee',
  strongGray: '#444444',
  gray: '#c8c9c7',
  yellow: '#f2af00',
  purple: '#6e2585',
  green: '#6ea204'
};
